import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  cursor: pointer;

  .dropdown {
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover .dropdown {
    opacity: 1;
  }

  &.current .dropdown {
    opacity: 1;
  }
`;
